import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestCadastroPosto({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'postos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;
    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteCadastroPosto({ payload }) {
  try {
    const { poco_codigo, params } = payload;
    yield call(api.delete, `postos/${poco_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));
    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { cadastroposto, params } = payload;

    yield call(api.post, 'postos', cadastroposto);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/unidade');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { poco_codigo } = payload;
    const { data } = yield call(api.get, `postos/${poco_codigo}`);
    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };
    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { cadastroposto, params } = payload;
    yield call(api.put, 'postos', cadastroposto);
    yield put(successRemove({ ...params, pesquisalista: true }));
    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/unidade');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'postos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@cadastroposto/CADASTROPOSTO_IN_REQUEST', requestCadastroPosto),
  takeLatest('@cadastroposto/DELETE_CADASTROPOSTO', deleteCadastroPosto),
  takeLatest('@cadastroposto/SUCCESS_REMOVE', requestCadastroPosto),
  takeLatest('@cadastroposto/STORE_CADASTROPOSTO', store),
  takeLatest('@cadastroposto/FIND_CADASTROPOSTO', find),
  takeLatest('@cadastroposto/UPDATE_CADASTROPOSTO', update),
  takeLatest('@cadastroposto/RECORD_FILTERING', applyedFilters),
]);
